var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current-balance"},[_c('p',[_vm._v("Saldo Atual")]),_vm._v(" "),_c('span',{style:({ color: _vm.minimumAchieved ? '#BF0000' : '#52CC9C' })},[_vm._v(_vm._s(_vm.currentBalance))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }